import * as caseTypes from './casesTypes';

const initialState = {
  viewTypes: ['myCase', 'teamCase'],
  currentViewType: 'myCase',
  caseIds: null,
  caseIdsFailure: false,
  caseDetails: {},
  caseDetailsHeader: {},
  caseManagerId: null,
  caseMessagesCount: 0,
  tableData: [],
  filters: {},
  caseDocuments: [],
  showFilterModal: false,
  immigrationPathwayList: [],
  casePhases: {},
  caseLineManagers: [],
  caseLineManagersErrors: null,
  caseClientLineManagersErrors: null,
  caseClientLineManagers: [],
  caseClientAddNewLineManagers: [],
  caseLineManagersCount: 0,
  lineManagersFilters: {},
  casesFilters: null,
  applicantCaseDetails: null,
  isLoading: false,
  bpfStatusInfo: null,
  isAdditionalInfoSecExist: false,
  hasAdditionalInfo: false,
  additionalInfoData: {},
  caseInfoData: {},
  newAdditionalInfoRecordId: null,
  tasksInfo: {
    tasks: [],
    isLoading: false,
  },
  activitiesInfo: {
    activities: [],
    isLoading: false,
  },
  messagesInfo: {
    count: 0,
    isLoading: false,
  },
  documentsInfo: {
    count: 0,
    isLoading: false,
  },
  contactsInfo: {
    contacts: [],
    isLoading: false,
  },
};

const casesReducer = (state = initialState, action) => {
  switch (action.type) {
    case caseTypes.GET_IMMIGRATION_PATHWAY_SUCCESS: {
      return { ...state, immigrationPathwayList: action.payload };
    }
    case caseTypes.GET_CASES_SUCCESS: {
      return { ...state, tableData: action.payload };
    }
    case caseTypes.GET_CASE_IDS_SUCCESS:
      return { ...state, caseIds: action.payload.cases };
    case caseTypes.GET_CASE_IDS_FAILURE:
      return { ...state, caseIdsFailure: true };

    case caseTypes.GET_CASE_DETAILS_SUCCESS:
      return { ...state, caseDetails: action.caseDetails, caseDetailsHeader: action.caseDetailsHeader };

    case caseTypes.GET_CASES_MESSAGES_COUNTS_SUCCESS: {
      return { ...state, caseMessagesCount: action.data.messages.length };
    }
    case caseTypes.GET_CASES_MESSAGES_COUNTS_FAILURE: {
      return { ...state, caseMessagesCount: 0 };
    }

    case caseTypes.RESET_CASES_MESSAGES_COUNTS: {
      return { ...state, caseMessagesCount: 0 };
    }
    case caseTypes.GET_CASE_DETAIL_FAILURE:
      return { ...state, caseDetailFailure: true };
    case caseTypes.SHOW_FILTER_MODAL:
      return {
        ...state,
        showFilterModal: action.status,
        anchorModal: action.anchorEl,
      };
    case caseTypes.STORE_CASE_DETAILS:
      return {
        ...state,
        caseDetails: action.caseDetails,
      };
    case caseTypes.STORE_CASE_MANAGER_ID:
      return {
        ...state,
        caseManagerId: action.caseManagerId,
      };
    case caseTypes.RESET_CASE_MANAGER_ID:
      return {
        ...state,
        caseManagerId: null,
      };
    case caseTypes.GET_FILTERS_SUCCESS:
      return {
        ...state,
        filters: action.payload.filters,
      };
    case caseTypes.HYDRATE_CASES:
      return {
        ...state,
        caseDocuments: action.payload,
      };
    case caseTypes.GET_CASE_PHASES_SUCCESS:
      return { ...state, casePhases: action.data };

    case caseTypes.GET_CASE_CLIENT_LM_ERROR:
      return {
        ...state,
        caseClientLineManagers: [],
        caseClientLineManagersErrors: action.payload,
      };
    case caseTypes.GET_CASE_LM_ERROR:
      return {
        ...state,
        caseLineManagers: [],
        caseLineManagersCount: 0,
        caseLineManagersErrors: action.payload,
      };
    case caseTypes.SET_CASE_LM_COUNT:
      return {
        ...state,
        caseLineManagersCount: action.payload,
      };
    case caseTypes.GET_CASE_LM_SUCCESS:
      return {
        ...state,
        caseLineManagersErrors: null,
        caseLineManagers: action.payload,
      };
    case caseTypes.GET_CASE_LM_FILTER_SUCCESS:
      let firstNameData =
        action.payload &&
        action.payload.map(item => {
          return item.firstName;
        });
      let lastNameData =
        action.payload &&
        action.payload.map(item => {
          return item.lastName;
        });
      return {
        ...state,
        lineManagersFilters: { firstNameList: firstNameData, lastNameList: lastNameData },
      };
    case caseTypes.GET_CASE_CLIENT_LM_SUCCESS:
      return {
        ...state,
        caseClientLineManagers: action.payload,
        caseClientLineManagersErrors: null,
      };
    case caseTypes.SAVE_CASE_CLIENT_NEW_LM_SUCCESS:
      return {
        ...state,
        caseAddNewLineManagers: action.payload,
      };
    case caseTypes.STORE_CASES_FILTERS:
      return { ...state, casesFilters: action.data };

    case caseTypes.GET_APPLICANT_CASE_DETAILS_SUCCESS:
      return { ...state, applicantCaseDetails: action.data };

    case caseTypes.FETCH_TASKS_SUCCESS: {
      return {
        ...state,
        tasksInfo: {
          ...state.tasksInfo,
          tasks: action.payload,
        },
      };
    }

    case caseTypes.LOADING_CASES: {
      return {
        ...state,
        isLoading: action.payload.isLoading,
      };
    }
    case caseTypes.LOADING_TASKS: {
      return {
        ...state,
        tasksInfo: {
          ...state.tasksInfo,
          isLoading: action.isLoading,
        },
      };
    }

    case caseTypes.FETCH_ACTIVITIES_SUCCESS: {
      return {
        ...state,
        activitiesInfo: {
          ...state.activitiesInfo,
          activities: action.payload,
        },
      };
    }
    case caseTypes.LOADING_ACTIVITIES: {
      return {
        ...state,
        activitiesInfo: {
          ...state.activitiesInfo,
          isLoading: action.isLoading,
        },
      };
    }

    case caseTypes.FETCH_MESSAGES_COUNT_SUCCESS: {
      return {
        ...state,
        messagesInfo: {
          ...state.messagesInfo,
          count: action.payload,
        },
      };
    }
    case caseTypes.LOADING_MESSAGES_COUNT: {
      return {
        ...state,
        messagesInfo: {
          ...state.messagesInfo,
          isLoading: action.isLoading,
        },
      };
    }

    case caseTypes.LOADING_DOCUMENTS_COUNT: {
      return {
        ...state,
        documentsInfo: {
          ...state.documentsInfo,
          isLoading: action.isLoading,
        },
      };
    }

    case caseTypes.FETCH_CONTACTS_SUCCESS: {
      return {
        ...state,
        contactsInfo: {
          ...state.contactsInfo,
          contacts: action.payload,
        },
      };
    }
    case caseTypes.LOADING_CONTACTS: {
      return {
        ...state,
        contactsInfo: {
          ...state.contactsInfo,
          isLoading: action.isLoading,
        },
      };
    }

    case caseTypes.RESET_CASE_DETAILS: {
      return {
        ...state,
        caseDetails: {},
        caseDetailsHeader: {},
        casePhases: {},
        applicantCaseDetails: null,
        tasksInfo: {
          tasks: [],
          isLoading: false,
        },
        activitiesInfo: {
          activities: [],
          isLoading: false,
        },
        messagesInfo: {
          count: 0,
          isLoading: false,
        },
        documentsInfo: {
          count: 0,
          isLoading: false,
        },
        contactsInfo: {
          contacts: [],
          isLoading: false,
        },
      };
    }

    case caseTypes.UPDATE_ADDITIONAL_INFO_STATUS: {
      return { ...state, isAdditionalInfoSecExist: action.isAdditionalInfoSecExist, hasAdditionalInfo: action.hasAdditionalInfo };
    }
    case caseTypes.UPDATE_ADDITIONAL_INFO_DATA: {
      return {
        ...state,
        isAdditionalInfoSecExist: action.isAdditionalInfoSecExist,
        hasAdditionalInfo: action.hasAdditionalInfo,
        additionalInfoData: action.additionalInfoData,
      };
    }
    case caseTypes.SET_BPF_STATUS_INFO: {
      return {
        ...state,
        bpfStatusInfo: action.bpfStatusInfo,
      };
    }
    case caseTypes.UPDATE_MAIN_CASE_INFO_DATA: {
      return { ...state, caseInfoData: action.caseInfoData };
    }
    case caseTypes.SET_NEW_ADDITIONAL_INFO_RECORD_ID: {
      return { ...state, newAdditionalInfoRecordId: action.newAdditionalInfoRecordId };
    }

    /*
    case documentsTypes.DEHYDRATE_DOCUMENT_DETAILS:
      return {
        ...state,
        documentDetail: {},
        documentDetailName: '',
        documentDetailType: '',
        documentDetailId: '',
      };
*/

    default:
      return state;
  }
};

export { initialState };
export default casesReducer;
